import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

function MaleStaffReport() {
  const location = useLocation();
  const { maleStaffData } = location.state || { maleStaffData: [] };
const navigate = useNavigate();
const udiseNumber = localStorage.getItem("udiseNumber");
   const [schoolData, setSchoolData] = useState(null); 
  // Function to handle printing
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);
     useEffect(() => {
        fetchSchoolData(); 
      }, );
  
  const handlePrint = () => {
    const printContent = document.querySelector('#print-content'); // Update to use id instead of class
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      const otherDetails = cloneContent.querySelectorAll('p'); 
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
      
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
      }
  
      const printWindow = window.open('', '', 'height=500,width=800');
      const table = printContent.querySelector('table');
      // const title = document.querySelector('h1');
      printWindow.document.write(`
        <style>
          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            border: 1px solid black;
             padding: 15px;
          }
             #print-content{
                margin: 20px; /* Add margin to the modal content */
              }
             @page{
             margin: 3mm;
             }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid black;
            padding: 10px;
            text-align: left;
          }
          th {
            background-color:#ecf0f1;
          }
          .print-container {
            border: 1px solid black;
            background-color: transparent;
          }
   @media print {
  .print-title {
    font-size: 20px;
    text-align: center;
    color: white;
    padding: 5px;
    background-color: black;
    border: 1px solid black;
    width: 20%;
    border-radius: 6px;
    margin: auto;
  }
}
}
          .main-content-of-page {
            border: 1px solid black;
            background-color: transparent;
          }
        </style>
      `);
      // printWindow.document.write(title.outerHTML);
      printWindow.document.write(table.outerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error("Element with ID 'print-content' not found.");
    }
  };
  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
};

const fetchSchoolData = () => {
  const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;

  fetch(firebaseDatabaseUrl)
    .then(response => response.json())
    .then(data => {
      setSchoolData(data); 
    })
    .catch(error => {
      console.error('Error fetching school data from Firebase:', error);
    });
};

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
      <div
        className="main-content-of-page"
        style={{
          flex: 1,
          padding: '20px',
          marginLeft: '250px', // Adjust based on sidebar width
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
        }}
      >
{/* Print-Specific Styles */}
        <style>
  {`
    @media print {
      body * {
        visibility: hidden; /* Hide everything by default */
      }
      .main-content-of-page, .main-content-of-page * {
        visibility: visible; /* Show only the main content */
      }
      .main-content-of-page {
        position: absolute;
        left: 0;
        top: 0;
        margin: 0 !important;
        padding: 0 !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        width: 100%;
      }
                @media print {
  .print-title {
    font-size: 4px;
    text-align: center;
    color: white;
    padding: 5px;
    background-color: black;
    border: 1px solid black;
    width: 20%;
    border-radius: 6px;
    margin: auto;
  }
}
      .print-container {
        border: none; /* Remove border for print */
        padding: 0; /* Remove padding for print */
        margin: 0; /* Remove margin for print */
      }
      .print-container table {
        background-color: transparent; /* Remove background color for print */
        border: none; /* Remove border for print */
      }
    
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }
      th, td {
        padding: 8px;
        text-align: center;
        border: 1px solid #ddd;
      }
      th {
        background-color: #ecf0f1!important;
        color: black !important;
        -webkit-print-color-adjust: exact; /* Ensure background color prints */
      }
      button {
        display: none; /* Hide the print button in print view */
      }
      .print-container {
        overflow-y: hidden; /* Hide scrollbar for print */
      }
    }
  `}
</style>
        {/* Wrapper div for print content */}
        <div  style={{
  border: '2px solid black',
  padding: '10px',
  margin: 'auto',
  width: '60%',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  marginTop: '0px',
  height: '780px', // Adjust the height to fit the content
  overflowY: 'auto', // Add vertical scrollbar
  borderRadius: '10px',
  backgroundColor: '#ffffff',}}>

<div style={{
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  marginBottom: '10px',
}}>
  <button
    className="print-btn"
    onClick={handlePrint}
    style={{
      backgroundColor: '#03365e',
      color: '#ffffff',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '16px',
      marginRight: '10px',
    }}
  >
    Print
  </button>
  <button
    style={{
      backgroundColor: '#dc3545',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '20px',
      fontWeight: 'bold',
    }}
    onClick={handleClose}
  >
    X
  </button>
</div>
   

      <div id="print-content">
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '42px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="3" style={{

                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px'
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>
                          <h1 
                          className="print-title"
                          style={{ margin: 'auto', textAlign: 'center', color: '#2c3e50',border: '1px solid black', width: '250px', height: '40px', fontSize: '20px', fontWeight: 'bold', backgroundColor: 'black', color: 'white',marginTop:'10px',padding: '10px',borderRadius:'4px' }}>
                        {language === "English" ? " Male Staff Report" : "पुरुष कर्मचारी अहवाल"}
                        </h1>
                        </th>
                      </tr>
                    )}

          <tr style={{ backgroundColor: '#ecf0f1', color: 'black' }}>
            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}> {language === "English" ? "Sr.No" : "अनु.क्र."}</th>
            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{language === "English" ? "Mobile Number " : "मोबाईल नंबर"}</th>
            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}> {language === "English" ? "Name" : "नाव"}</th>
          </tr>
        </thead>
        <tbody>
          {maleStaffData.map((employee, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                transition: 'background-color 0.3s ease',
              }}
            >
              <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{index + 1}</td>
              <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{employee.mobile}</td>
              <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{employee.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  </div>
</div>
  );
}

export default MaleStaffReport;